import React from "react";
import ViewRelease from "../../components/view-release/view-release";
import useTitle from "../../hooks/useTitle";
import { isLoggedIn } from "../../utils/auth";
import { AUTH_SCREEN } from "../../utils/url";

export default function ViewReleasePage() {
  useTitle("Preview");

  if (!isLoggedIn()) {
    window.location = "/";
    return null;
  }

  return (
    <div className="p-3 w-full h-full overflow-y-auto">
      <ViewRelease />
    </div>
  );
}
